import React, { useState, useEffect } from 'react';
import { Button, FormControl, Grid, TextField } from "@mui/material";
import { grey } from '@mui/material/colors';

const OrgTypeConfigurePopup = ({ editedRecord, setOpenPopup, onSave }) => {

    const initialValues = {
        org_name: "",
        contact_person_name: "",
        contact_email: "",
        contact_mobile_number: "",
        org_department: ""
    };

    const [orgData, setOrgData] = useState(initialValues);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (editedRecord != null) {
            setOrgData({
                ...initialValues,
                ...editedRecord,
            });
        } else {
            setOrgData(initialValues);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedRecord]);

    const validate = (fieldValues) => {
        let temp = { ...errors };

        if ("org_name" in fieldValues) {
            temp.org_name = fieldValues.org_name === "" ? "Org Name is required" : "";
        }
        if ("contact_person_name" in fieldValues) {
            temp.contact_person_name = fieldValues.contact_person_name === "" ? "Contact Person is required" : "";
        }
        if ("contact_mobile_number" in fieldValues) {
            temp.contact_mobile_number = fieldValues.contact_mobile_number === ""
                ? ""
                : !/^\d{10}$/.test(fieldValues.contact_mobile_number)
                    ? "Enter a valid 10-digit mobile number"
                    : "";
        }
        if ("contact_email" in fieldValues && fieldValues.contact_email !== "") {
            temp.contact_email = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValues.contact_email)
                ? "Enter a valid contact_email address"
                : "";
        } else if ("contact_email" in fieldValues) {
            temp.contact_email = "";
        }

        setErrors({ ...temp });
        return Object.values(temp).every((x) => x === "");
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setOrgData({ ...orgData, [name]: value });
        Object.values(errors).some((res) => res !== "") &&
            validate({ ...orgData, [name]: value });
    };

    const handleSubmit = () => {
        if (validate(orgData)) {
            if (onSave) {
                onSave(orgData);
            }
        }
    };

    return (
        <>
            <Grid container>
                <Grid container>
                    {/* Org Name */}
                    <Grid item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth>
                            <TextField
                                size="small"
                                required
                                value={orgData?.org_name}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                id="org_name"
                                label="Org Name"
                                name="org_name"
                                {...(errors.org_name && {
                                    error: true,
                                    helperText: errors.org_name,
                                })}
                            />
                        </FormControl>
                    </Grid>

                    {/* Contact Person */}
                    <Grid item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth>
                            <TextField
                                size="small"
                                required
                                value={orgData?.contact_person_name}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                id="contact_person_name"
                                label="Contact Person"
                                name="contact_person_name"
                                {...(errors.contact_person_name && {
                                    error: true,
                                    helperText: errors.contact_person_name,
                                })}
                            />
                        </FormControl>
                    </Grid>
                    {/* Email */}
                    <Grid item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth>
                            <TextField
                                size="small"
                                required
                                value={orgData?.contact_email}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                disabled={editedRecord?.contact_email}
                                id="contact_email"
                                label="Email"
                                name="contact_email"
                                type="contact_email"
                                {...(errors.contact_email && {
                                    error: true,
                                    helperText: errors.contact_email,
                                })}
                            />
                        </FormControl>
                    </Grid>

                    {/* Mobile */}
                    <Grid item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth>
                            <TextField
                                size="small"
                                value={orgData?.contact_mobile_number || ""}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                type='number'
                                id="contact_mobile_number"
                                label="Mobile"
                                name="contact_mobile_number"
                                inputProps={{ maxLength: 10 }}
                                {...(errors.contact_mobile_number && {
                                    error: true,
                                    helperText: errors.contact_mobile_number,
                                })}
                            />
                        </FormControl>
                    </Grid>
                    {/* Department */}
                    <Grid item xs={12} md={6} sx={{ marginTop: "1rem", paddingRight: "15px", paddingLeft: "15px" }}>
                        <FormControl fullWidth>
                            <TextField
                                size="small"
                                value={orgData?.org_department || ""}
                                onChange={handleInputChange}
                                variant="outlined"
                                fullWidth
                                id="org_department"
                                label="Department"
                                name="org_department"
                                {...(errors.org_department && {
                                    error: true,
                                    helperText: errors.org_department,
                                })}
                            />
                        </FormControl>
                    </Grid>
                    
                </Grid>

                {/* Action Buttons */}
                <Grid
                    container
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                    <Button
                        sx={{ marginTop: "1rem", marginRight: "1rem", ":hover": { color: grey[50] } }}
                        variant="outlined"
                        onClick={() => setOpenPopup(false)}
                        className="mpl-secondary-btn"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        className="mpl-primary-btn"
                        sx={{ marginTop: "1rem", marginRight: "1rem" }}
                    >
                        {editedRecord ? "Update" : "Save"}
                    </Button>
                </Grid>
            </Grid>
        </>
    );
};

export default OrgTypeConfigurePopup;
